﻿export const tariffs = (function () {
    class Tariff {
        constructor(id, name, price, isDefault) {
            this.id = id;
            this.name = name;
            this.price = price;
            this.isDefault = isDefault;
        }

        async get(tariffId) {
            const outJson = {
                action: 'tariffGet',
                data: {
                    tariffId
                }
            };
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(outJson)
            });

            const result = await response.json();
            this.id = result.Id;
            this.name = result.Name;
            this.price = result.Price;
            this.price = result.IsDefault
            return this;
        }
    }

    class CurrentTariff extends Tariff {
        constructor(id, name, price, isDefault, start, end) {
            super(id, name, price, isDefault);
            this.start = start;
            this.end = end;
        }

        async get(companyId) {
            const outJson = {
                action: 'currentTariffGet',
                data: {
                    companyId
                }
            };
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(outJson)
            });

            const result = await response.json();

            this.id = result.Id;
            this.name = result.Name;
            this.price = result.Price;
            this.isDefault = result.IsDefault;
            this.start = new Date(parseInt(/-?\d+/.exec(result.Start)[0]));
            this.end = new Date(parseInt(/-?\d+/.exec(result.End)[0]))

            return this;
        }
    }

    class Period {
        constructor(id, tariffId, month, discount) {
            this.id = id;
            this.tariffId = tariffId;
            this.month = month;
            this.discount = discount;
        }
    }

    const url = "/tariffApi";
    const method = 'POST';

    async function tariffsGet() {
        let tariffs = [];
        const outJson = {
            action: 'tariffsGet'
        };
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });

        const results = await response.json();

        for (const result of results) {
            tariffs.push(new Tariff(result.Id, result.Name, result.Price))
        }

        return tariffs;
    };

    async function periodsGet(tariffId) {
        let periods = [];
        const outJson = {
            action: 'periodsGet',
            data: {}
        };

        if (tariffId !== undefined && typeof (tariffId) == 'number') {
            outJson.data['tariffId'] = tariffId;
        }
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });

        const results = await response.json();

        for (const result of results) {
            periods.push(new Period(result.Id, result.TariffId, result.Month, result.Discount))
        }

        return periods;
    }

    return {
        tariffsGet: tariffsGet,
        Tariff: Tariff,
        Period: Period,
        CurrentTariff: CurrentTariff,
        periodsGet: periodsGet
    }
})();